export function StyledBooleanFalseSign() {
  return (
    <svg width='16' height='16' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M 2.6,2.6 11.4,11.4' stroke='#FF0000' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M 11.4,2.6 2.6,11.4' stroke='#FF0000' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
